import { render, staticRenderFns } from "./NewWaybillExit.vue?vue&type=template&id=df95e0b2&scoped=true&"
import script from "./NewWaybillExit.vue?vue&type=script&lang=js&"
export * from "./NewWaybillExit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df95e0b2",
  null
  
)

export default component.exports